import React from "react";
// import ParkerLogo from "../assets/images/webp/companygrid_4.png";
// import BondioliLogo from "../assets/images/webp/bondioli_logo.png";
// import CalzoniLogo from "../assets/images/webp/calzoni_logo.png";
// import DenisonLogo from "../assets/images/webp/companygrid_1.png";
// import TaiyoLogo from "../assets/images/webp/companygrid_3.png";


// import ParkerLogo from "../assets/images/webp/"
const companies = [
  { img: "/assets/image/parker.png", link: "https://www.parker.com/" },
  { img: "/assets/image/taiyo.png", link: "https://taiyoindia.com/" },
  { img: "/assets/image/calzoni_logo.png", link: "https://calzoni-hydraulics.com/" },
  { img: "/assets/image/denison.png", link: "https://ph.parker.com/us/en/series/hydrostatic-pumps?facet=ads_f219503_ntk_cs%253A%2522Hydraulic%2BPump%2Band%2BPower%2BSystems%2BDivision%2522" },
  {
    img: "/assets/image/bondioli_logo.png",
    link: "https://bondioli-pavesi.com/en/bondioli-pavesi-india-pvt-ltd-0",
  },
];

const ImageGrid = () => {
  return (
    <div className="w-full grid grid-cols-1 px-20 lg:p-0 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
      {companies.map((company, index) => (
        <a
          key={index}
          href={company.link}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full h-[150px] bg-white lg:border border-gray-300 
          flex items-center justify-center transition-all duration-300 
          lg:hover:bg-[#2C353D] group"
        >
          <img
            src={company.img}
            alt={`Company ${index + 1}`}
            className="max-w-[80%] h-auto 
             brightness-0 group-hover:bg-black/70 lg:group-hover:bg-transparent  group-hover:brightness-100 "
          />
        </a>
      ))}
    </div>
  );
};

export default ImageGrid;

// import React from "react";
// import { Grid, Box } from "@mui/material";
// import ParkerLogo from "../assets/images/webp/parker_logo.webp";
// import BondioliLogo from "../assets/images/webp/bondioli_logo.webp";
// import CalzoniLogo from "../assets/images/webp/calzoni_logo.webp";
// import DenisonLogo from "../assets/images/webp/denison_logo.webp";
// import TaiyoLogo from "../assets/images/webp/taiyo_logo.webp";

// const companies = [
//   { img: ParkerLogo, link: "https://www.parker.com/" },
//   { img: TaiyoLogo, link: "https://taiyoindia.com/" },
//   { img: CalzoniLogo, link: "https://calzoni-hydraulics.com/" },
//   { img: DenisonLogo, link: "https://denison-hydraulics.com/" },
//   {
//     img: BondioliLogo,
//     link: "https://bondioli-pavesi.com/en/bondioli-pavesi-india-pvt-ltd-0",
//   },
// ];

// const ImageGrid = () => {
//   return (
//     <Grid
//       spacing={2}
//       sx={{
//         width: "auto",
//         justifyContent: "center",
//         display: "flex",
//         flexWrap: "wrap",
//         marginTop: 4,
//         padding: "0 16px", // Add padding to the left and right
//       }}
//     >
//       {companies.map((company, index) => (
//         <Grid
//           item
//           key={index}
//           xs={6} // Half width on extra-small screens
//           sm={4} // One-third width on small screens
//           md={3} // One-fourth width on medium screens
//           lg={2} // One-sixth width on large screens
//           xl={2} // One-sixth width on extra-large screens
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <Box
//             component="a"
//             href={company.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             sx={{
//               width: "100%",
//               height: "150px", // Reduced height
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               backgroundColor: "#FFFFFF",
//               transition: "background-color 0.3s ease-in-out",
//               "&:hover": {
//                 backgroundColor: "#2C353D",
//                 "& img": {
//                   filter: "brightness(0) invert(1)",
//                 },
//               },
//               border: "1px solid #D4D4D4",
//               textDecoration: "none",
//               margin: "8px", // Add margin to ensure space between items
//             }}
//           >
//             <img
//               src={company.img}
//               alt={`Company ${index + 1}`}
//               style={{
//                 maxWidth: "80%", // Reduced max width
//                 height: "auto",
//                 transition: "filter 0.3s ease-in-out",
//               }}
//             />
//           </Box>
//         </Grid>
//       ))}
//     </Grid>
//   );
// };

// export default ImageGrid;
